<ion-header>
    <ion-toolbar>
        <ion-title>{{'components.job.modal-feedback.title' | translate}}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="modalCtrl.dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-card>
        <ion-card-content>
            <ion-list>

                <ion-radio-group [(ngModel)]="data.userApproved" value="classification">
                    <ion-list-header>
                        <ion-label>{{'components.job.modal-feedback.label-classification' | translate}}</ion-label>
                    </ion-list-header>

                    <ion-item>
                        <ion-label>{{'components.job.modal-feedback.label-correct' | translate}}</ion-label>
                        <ion-radio slot="start" [value]="true"></ion-radio>
                    </ion-item>

                    <ion-item>
                        <ion-label>{{'components.job.modal-feedback.label-not-correct' | translate}}</ion-label>
                        <ion-radio slot="start" [value]="false"></ion-radio>
                    </ion-item>
                </ion-radio-group>

                <ion-item>
                    <ion-label position="floating">{{'components.job.modal-feedback.label-comment' | translate}}</ion-label>
                    <ion-textarea [(ngModel)]="data.comment"></ion-textarea>
                </ion-item>

            </ion-list>
        </ion-card-content>
    </ion-card>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-buttons slot="end">
            <ion-button color="primary" (click)="modalCtrl.dismiss();">
                {{'shared.btn-cancel' | translate}}
            </ion-button>
            <ion-button color="secondary"
                        (click)="modalCtrl.dismiss(data);">
                {{'shared.btn-submit' | translate}}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
